import { onlyNumbers } from 'utils/number';
import { LateChargesFields, lateChargesBody, lateFormOf } from 'utils/lateCharges';

export type CreateChargeFormData = {
  document: string;
  description: string;
  amount: number;
  name: string;
  dueDate: string;
  maxInstallments: number;
  itens: { description: string; amount: number }[];
  paymentMethod: 'PIX' | 'BILLET';
} & LateChargesFields;

/**
 * Corpo de `POST /charges` a partir do formulário. Encargo vazio não vai (vale
 * o padrão da conta) e vale para Pix e boleto: o Pix com vencimento também
 * registra multa e juros. O pagador só vai no boleto ou quando o usuário marcou
 * "Informar dados do pagador": ao trocar Boleto por Pix, o que ficou digitado
 * nos campos (agora ocultos) não pode virar devedor da cobrança.
 */
export const buildCreateChargeBody = (
  data: CreateChargeFormData,
  options: { feeFromPayer: boolean; showPayer: boolean },
) => ({
  amount: data.amount,
  description: data.description,
  dueDate: data.dueDate,
  ...(data.paymentMethod === 'BILLET' || options.showPayer
    ? { name: data.name, document: onlyNumbers(data.document) }
    : {}),
  ...(data.itens?.length ? { itens: data.itens } : {}),
  feeType: (options.feeFromPayer ? 'FROM_PAYER' : 'FROM_CUSTOMER') as 'FROM_PAYER' | 'FROM_CUSTOMER',
  intermediary: false,
  releaseInDays: 0,
  maxInstallments: data.maxInstallments ? +data.maxInstallments : null,
  paymentMethod: data.paymentMethod,
  ...lateChargesBody(lateFormOf(data)),
});
